// import Vue from "vue";
// import VueRouter from "vue-router";
import store from "../state/store";
import { sessionEnded } from "@/utils/session-state";

import {createWebHistory, createRouter} from "vue-router";
import routes from "./routes";
import qs from 'qs'
import {portalScrollBehavior} from '@/utils/portal-navigation';

// import VueMeta from "vue-meta";

// Vue.use(VueRouter);

// Vue.use(VueMeta, {
//   // The component option name that vue-meta looks for meta info on.
//   keyName: "page",
// });

// a belépés a localStorage-ben is megvan: egy új fül (vagy levélből nyitott link) is belépve indul
const storedAuthenticated = () => {
    try {
        return JSON.parse(sessionStorage.getItem('authenticated') || localStorage.getItem('authenticated'));
    } catch (e) {
        return null;
    }
};

const router = createRouter({
    history: createWebHistory(),
    parseQuery: (query) => {
        return qs.parse(query)
    },
    stringifyQuery(query) {
        const result = qs.stringify(query, { encodeValuesOnly: true })
        return result || ''
    },
    routes, // mode: "history",
    scrollBehavior: portalScrollBehavior,
});

// Before each route evaluates...
router.beforeEach(async (routeTo, routeFrom, next) => {
    const authRequired = routeTo.matched.some(matched => matched.meta.authRequired);
    let authenticated = store?.getters["auth/authenticated"] || storedAuthenticated();
    const can = store?.getters['auth/can'];
    let locale = store?.getters['trans/locale'];
    let key = 'routes.'+routeTo.fullPath;
    const translation = store.$t('routes.'+routeTo.fullPath, {}, locale);
    // Előbb a belépés, csak utána a jogosultság: egy be nem lépett látogatónak nincs
    // jogosultság-listája, így a jog-ellenőrzés minden védett oldalt 404-re vitt, és a
    // belépés után is oda tért vissza (`/login?redirectFrom=/error/404-basic`, éles, 2026-09-23).
    // lejárt munkamenet a következő belépésig: védett oldal nem tölt be (l. api/axios.js)
    if (authRequired && (!authenticated || sessionEnded())) {
        return next({name: "login", query: {redirectFrom: routeTo.fullPath}, replace: true});
    }

    if (authRequired && routeTo.name !== 'error-404-basic' && routeTo.path !== '/') {
        const route = routeTo.matched
            .slice()
            .reverse()
            .find((record) => record.meta.permissionRoute)?.meta.permissionRoute
            || router.getRoutes().find((route) => route.name === routeTo.name)?.path;
        const type = routeTo.matched[1]?.meta?.type;

        if (!can(type+'.menu_points.'+route)) {
            next({name: "error-404-basic", replace: true});
            return false;
        }
    }

    if (key !== translation) {
        routeTo.fullPath = translation;
        routeTo.path = translation;
        routeTo.href = translation;
    }

    //   // If auth isn't required for the route, just continue.
    if (!authRequired) {
        next()
    } else {
        // console.log(2)
        if (!authenticated) {
            // console.log(3)
            return next({name: "login", query: {redirectFrom: routeTo.fullPath}, replace: true});
        }
        // console.log(4)
        next();
    }

    // next()

    // eslint-disable-next-line no-unused-vars
    // eslint-disable-next-line no-inner-declarations
    /*function redirectToLogin() {
        // Pass the original route to the login component
        next({name: "login", query: {redirectFrom: routeTo.fullPath}});
    }*/

});

// router.beforeResolve(async (routeTo, routeFrom, next) => {
// Create a `beforeResolve` hook, which fires whenever
// `beforeRouteEnter` and `beforeRouteUpdate` would. This
// allows us to ensure data is fetched even when params change,
// but the resolved route does not. We put it in `meta` to
// indicate that it's a hook we created, rather than part of
// Vue Router (yet?).
// try {
//   // For each matched route...
//   for (const route of routeTo.matched) {
//     await new Promise((resolve, reject) => {
//       // If a `beforeResolve` hook is defined, call it with
//       // the same arguments as the `beforeEnter` hook.
//       if (route.meta && route.meta.beforeResolve) {
//         route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
//           // If the user chose to redirect...
//           if (args.length) {
//             // If redirecting to the same route we're coming from...
//             // Complete the redirect.
//             next(...args);
//             reject(new Error("Redirected"));
//           } else {
//             resolve();
//           }
//         });
//       } else {
//         // Otherwise, continue resolving the route.
//         resolve();
//       }
//     });
//   }
//   // If a `beforeResolve` hook chose to redirect, just return.
// } catch (error) {
//   return;
// }

// // If we reach this point, continue resolving the route.
// next();
// });

export default router;
